module.exports = __webpack_public_path__ + "img/NukedTV-Web_21.a35d5261.png";